import { MenuItem, Select, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormEvent } from 'react';
import { Category } from '../../types/category';
import { RatingSentence } from '../../types/rating-sentence';

interface RatingSentenceEditDialogProps {
  onClose: () => void;
  onConfirm: (updatedRating: RatingSentence) => void;
  rating: RatingSentence | null;
  categories: Category[];
  subjectName: string;
}

const RatingSentenceEditDialog: React.FC<RatingSentenceEditDialogProps> = ({
  onClose,
  onConfirm,
  rating,
  categories,
  subjectName,
}) => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);

    const updatedRating: RatingSentence = {
      text: (formData.get('text') as string).trim(),
      categoryId: formData.get('category') as string,
    };
    const feminine = (formData.get('feminine') as string | undefined)?.trim();

    if (feminine) updatedRating.feminine = feminine;

    if (rating) {
      if (
        rating.text === updatedRating.text &&
        rating.feminine === updatedRating.feminine &&
        rating.categoryId === updatedRating.categoryId
      ) {
        onClose();
        return;
      }
      updatedRating.id = rating.id;
    }

    onConfirm(updatedRating);
  };

  const getTitle = () => {
    if (subjectName === '') {
      return `${rating ? 'Upravit' : 'Vytvořit'} univerzální hodnotící větu`;
    }

    return `${
      rating ? 'Upravit' : 'Vytvořit'
    } hodnotící větu pro předmět ${subjectName}`;
  };

  return (
    <Dialog
      open
      onClose={onClose}
      disableRestoreFocus
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
      }}
    >
      <DialogTitle>{getTitle()}</DialogTitle>
      <DialogContent>
        <Select
          required
          fullWidth
          variant="standard"
          id="category"
          name="category"
          defaultValue={rating?.categoryId ?? categories[0].id!.toString()}
        >
          {categories.map((category) => (
            <MenuItem
              key={category.id!.toString()}
              value={category.id!.toString()}
            >
              {category.name}
            </MenuItem>
          ))}
        </Select>
        <TextField
          autoFocus
          required
          margin="dense"
          id="text"
          name="text"
          label="Text hodnocení"
          type="text"
          fullWidth
          variant="standard"
          defaultValue={rating?.text}
          inputProps={{
            pattern: '\\s*\\S+.*',
            title: 'Text hodnocení nesmí být prázdný',
          }}
        />
        <TextField
          margin="dense"
          id="feminine"
          name="feminine"
          label="Ženský rod"
          type="text"
          fullWidth
          variant="standard"
          defaultValue={rating?.feminine}
        />
        <DialogContentText fontSize={11}>
          Pokud je hodnotící věta v ženském rodě jiná než v rodě mužském či
          středním, vyplňte i pole pro ženský rod.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Zrušit</Button>
        <Button variant="contained" type="submit">
          {rating ? 'Uložit' : 'Vytvořit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RatingSentenceEditDialog;
